import store from '../store'

export function reorderTabs(tabGroups,orderedTabGroups) {

	const state = store.getState()
	
	store.dispatch({type:'UPDATE_OPEN_TAB_GROUPS',tabGroups:tabGroups,orderedTabGroups:orderedTabGroups})
	
}